export default __webpack_public_path__ + "static/media/sorteo-header-movil.c8f5aeec.png";